<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1 style="padding-top:150px;">Acknowledgement</h1><br/>
<p style="font-family:Times New Roman;">First, I wish to acknowledge Jing Lu for her patience and accurate translation of my novel from English into Mandarin. Her enthusiastic support and comments on Chinese culture were vital to the completion of the novel. The English version was improved and edited by Sue Groves, who helped remove stilted phrases.</p>
<p style="font-family:Times New Roman;">The concept of a mystical novel based around a geological and mining theme initially came from Sheng-Xun Sai. I am indebted to him and a group of other graduate students from the China University of Geosciences, Beijing (CUGB); Liang Zhang, Xinhua Wang and Ri Han, for helping develop an outline of the plot of the novel and commenting on its content, particularly helping it remain true to Chinese culture. I also thank Professors Jun Deng and Liqiang Yang for their invitation to teach at CUGB without which the concept of this novel would not have developed. Changshun Jia played a key role in editing the novel in terms of correctness of exploration content and the Mandarin translation to better fit Chinese conversation and customs. Kunfeng Qiu (QQ), Lingling Yang (Vera) and Huayan Pian (Cathy) also provided encouragement after reading the outline.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?85437c64